import { useRef } from "react"

import Style from "./style"

import usePutParticipantRanking from "entity/event/usePutParticipantRanking"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"


const ChangeRankModal = ({ participantSelect, closeEvent }) => {
    const rankRef = useRef()

    const [putRanking] = usePutParticipantRanking(participantSelect, rankRef)

    return (
        <DefaultModal title="순위 변경" closeEvent={closeEvent}>
            <Style.Wrapper>
                <input placeholder="순위 입력" ref={rankRef} />
                <DefaultButton small fitWidth clickEvent={putRanking}>적용</DefaultButton>
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default ChangeRankModal